// extracted by mini-css-extract-plugin
module.exports = {"paper":"common_paper__1r4jt","darkLabel":"common_darkLabel__2RbvK","linkButton":"common_linkButton__3S2Ki"};